import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/input/containers/input.container';

export default function GlobalHsCodeBasicInfoComponent({
  handleInnerFormChange, selectedGlobalHsCodes
}: any) {

  return (
    <>
      <AccordionContainer
        child={
           <div className='grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
              label="HSN/SAC Codes"
              name="HSCodes"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'HSCodes',
                )
              }}
              type="text"
              value={selectedGlobalHsCodes?.HSCodes}
              isDisabled
            />
            <InputContainer
              label="Description"
              name="Description"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Description',
                )
              }}
              type="text"
              value={selectedGlobalHsCodes?.Description}
              isDisabled
            />
          </div>
        }
        expandedPanel="userInfo"
        headerTitle="Basic Information"
      />
    </>
  )
}